/**
 * Synapsy Widget - CSS Inline Styles
 * Funções que retornam CSS inline para componentes do widget
 */

// Sombra de destaque do launcher (e do balão, que reusa a mesma sombra).
const LAUNCHER_SHADOW =
  "rgba(0, 0, 0, 0.06) 0px 1px 6px 0px, rgba(0, 0, 0, 0.16) 0px 2px 24px -5px";

// Cores do balão de mensagem.
const BUBBLE_BG = "#FFFFFF"; // pílula branca (igual à referência)
const BUBBLE_TEXT_COLOR = "#1A1A1A"; // texto escuro/bold sobre o branco
const BUBBLE_CLOSE_COLOR = "#666666";

/**
 * Retorna estilos CSS para o launcher
 * @param {string} position - 'left' ou 'right'
 * @returns {string} CSS inline
 */
export function getLauncherStyles(position) {
  const baseStyles = `
    position: fixed;
    bottom: 20px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #ffffff;
    color: white;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: ${LAUNCHER_SHADOW};
    z-index: 999999;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  `;

  const positionStyles = position === "left" ? "left: 20px;" : "right: 20px;";

  return baseStyles + positionStyles;
}

/**
 * Retorna estilos CSS para o balão de mensagem ("Como posso ajudar?")
 * Pílula branca ancorada ao LADO do launcher (à esquerda do avatar quando
 * position="right"), centralizada verticalmente com ele. Uma linha no caso
 * normal; em telas estreitas o max-width faz o texto quebrar em vez de
 * ultrapassar a borda. Reusa a sombra do launcher. Sem rabicho (igual à referência).
 * @param {string} position - 'left' ou 'right'
 * @returns {string} CSS inline
 */
export function getBubbleStyles(position) {
  const baseStyles = `
    position: fixed;
    bottom: 46px;
    padding: 10px 16px;
    background: ${BUBBLE_BG};
    color: ${BUBBLE_TEXT_COLOR};
    font-size: 15px;
    font-weight: 700;
    line-height: 1.3;
    max-width: calc(100vw - 108px);
    box-shadow: ${LAUNCHER_SHADOW};
    display: flex;
    align-items: center;
    cursor: pointer;
    z-index: 999999;
  `;

  const radiusStyles = position === "left"
    ? "border-radius: 16px 16px 16px 0;"
    : "border-radius: 16px 16px 0 16px;";
  const positionStyles = position === "left" ? "left: 93px;" : "right: 93px;";

  return baseStyles + radiusStyles + positionStyles;
}

/**
 * Retorna estilos CSS para o botão "X" de dispensar o balão.
 * Canto superior direito, dentro do balão (que é position:fixed). Glifo
 * preto discreto; alvo de toque confortável (~24px) p/ mobile.
 * @returns {string} CSS inline
 */
export function getBubbleCloseStyles() {
  return `
    position: absolute;
    top: -8px;
    right: -8px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    line-height: 1;
    color: ${BUBBLE_CLOSE_COLOR};
    background: ${BUBBLE_BG};
    border-radius: 50%;
    box-shadow: 0 1px 4px rgba(0,0,0,0.15);
    cursor: pointer;
  `;
}

/**
 * Retorna estilos CSS para o iframe container
 * @param {string} position - 'left' ou 'right'
 * @returns {string} CSS inline
 */
export function getIframeStyles(position) {
  const baseStyles = `
    position: fixed;
    bottom: 20px;
    width: min(400px, calc(100vw - 40px));
    height: 600px;
    max-height: calc(100vh - 120px);
    border: none;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    z-index: 999998;
    background: white;
  `;

  const positionStyles = position === "left" ? "left: 20px;" : "right: 20px;";

  return baseStyles + positionStyles;
}

/**
 * Retorna estilos CSS para o loading indicator
 * @returns {string} CSS inline
 */
export function getLoadingStyles() {
  return `
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 40px;
    height: 40px;
    border: 3px solid rgba(102, 126, 234, 0.3);
    border-top-color: #667eea;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    z-index: 999999;
  `;
}

/**
 * Retorna estilos CSS para o error state
 * @returns {string} CSS inline
 */
export function getErrorStyles() {
  return `
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #ef4444;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999999;
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
  `;
}
